import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { useFormField } from './use-form-field';

type FormMessageProps = { className?: string; description?: ReactNode };

/** The field error, or the muted description when there is no error (they share one line). */
export function FormMessage({ className, description }: FormMessageProps) {
  const { error, messageId, descriptionId } = useFormField();
  if (error) {
    return (
      <p
        id={messageId}
        data-slot="form-message"
        className={cn('text-danger-text text-meta', className)}
      >
        {error}
      </p>
    );
  }
  if (!description) return null;
  return (
    <p
      id={descriptionId}
      data-slot="form-description"
      className={cn('text-meta text-muted', className)}
    >
      {description}
    </p>
  );
}
